import { IModuleConfiguration, ModuleConfiguration } from 'src/types/system_types';
import { IAHPConfiguration } from 'src/core/configuration';

import ess from'../../../pip/library/pi-ess/pi-ess.js';
import tt from'../../../pip/library/pi-tt/pi-tt.js';
import $ip from'../../../pip/library/pi-ip/pi-ip.js';

export type t_environment = 'local' | 'dev' | 'qa' | 'impl' | 'prod';
export type t_release = 'dev' | 'prod';
export type t_constant = string;

export interface IViewModuleConfiguration extends IModuleConfiguration {
  /**
   * more constants to share with `safe`
   */
  constants: Record<string, t_constant>;
  /**
   * @internal to push the environment and release on to a HIL script
   */
  system: {
    environment?: t_environment;
    release?: t_release;
  };
}

export class ViewModule extends ModuleConfiguration {
  configuration: IViewModuleConfiguration;

  /**
   *
   * @param configuration
   */
  initialize(configuration: IViewModuleConfiguration, allConfiguration: IAHPConfiguration) {
    return new Promise((resolve) => {
      this.configuration = this.__addHostnameConstants(this.__defaultConfiguration(configuration), allConfiguration);

      $ip.constants.upgrade(this.configuration.constants);
      resolve(this.configuration);
    });
  }

  private __defaultConfiguration(configuration: IViewModuleConfiguration) {
    return tt.merge(
      {
        system: {
          // this is used internally to push the environment and release on to a HIL script
        },
        constants: {
          '@tenant': 'tenant',
          '@client': '.',
          '@platform': '@client/platform',
          '@tenants': '@client/tenants',
          '@aux': '@client/auxiliary',
          '@def': '@aux/definitions',
          '@res': '@aux/resources',
          '@data': '@aux/data',
          '@views': '@client/views',
          '@nav': '@views/navigation',
          '@imports': '@client/imports',
          '@base_uri': `${window.location.origin}/${window.location.pathname}`,
          '@origin': `${window.location.origin}`,
          // NOTE this is different because it is loaded from inside of ahp
          '@middleware': '@base_uri/imports/middleware'
        }
      },
      configuration
    ) as IViewModuleConfiguration;
  }

  /**
   * pull out the tenant from the hostname, if there is a hostname match.
   * if we get a tenant then we add it to named paths so it can be used
   * to look up the `tenant` json
   */
  private __addHostnameConstants(configuration: IViewModuleConfiguration, allConfiguration: IAHPConfiguration) {
    const hostnameLocator = allConfiguration.navigation.hostname;

    if (!hostnameLocator || hostnameLocator.length <= 0) {
      return configuration;
    }

    const hostnameLocatorUnits = hostnameLocator.replace(/\S\s/g, '').split('.');
    const hostnameUnits = location.hostname.split('.');

    if (hostnameUnits.length !== hostnameLocatorUnits.length) {
      ess.warning({
        ns: 'ahp',
        site: 'routing',
        action: 'discover_tenant',
        data: {
          tip: 'set ahp.routing.hostname to null to disable this warning.',
          hostname: location.hostname,
          hostnameLocator
        }
      });

      return configuration;
    }

    let hasTenant = false;

    tt.each((unit, index: number) => {
      // TODO read `@` from HIL.dsl.assignment
      if (unit[0] === '@') {
        configuration.constants[unit] = hostnameUnits[index];
      }
      if (unit === '@tenant') {
        hasTenant = true;
      }
    }, hostnameLocatorUnits);

    if (!hasTenant) {
      ess.failure({
        ns: 'ahp',
        site: 'routing',
        action: 'discover_tenant',
        data: {
          hostname: location.hostname,
          hostnameLocator
        }
      });
    }

    return configuration;
  }
}
